import {
    IconHeartFill,
    IconHeartOutline,
    IconLiveCircleTip,
    IconPostStats,
} from 'assets/svg/sprite'
import { addToast } from 'components/Toast/Toast'
import TipModal from 'components/UI/Modal/Tip/TipModal'
import { useModalContext } from 'context/modalContext'
import { useUserProfile } from 'store'

import styles from './postStorySidebar.module.scss'

interface Props {
    showStats: boolean
    amount: number
    liked: boolean
    likeCount: number
    isEnabled: boolean
    toggleStats: () => void
    toggleLiked: () => void
    isOwner: boolean
    modelData: {
        postId?: string
        storyId?: string
        modelId: string
        avatarSrc: string
    }
    onTipModal?: () => void
}

export const PostStorySidebar = ({
    isEnabled,
    showStats,
    amount,
    liked,
    isOwner,
    likeCount,
    toggleStats,
    toggleLiked,
    modelData
}: Props) => {
    const modal = useModalContext()
    const userData = useUserProfile()

    const openTipModal = () => {
        if (userData?.status === 'restricted' && userData?.role === 'fan') {
            addToast('error', 'Your account is restricted.')
            return
        }
    
    
        modal.addModal('Tip', <TipModal tipType="story" modelData={modelData} />)
    }

    return (
        <div className={styles.postStorySidebar}>
            {showStats && isOwner && (
                <div className={styles.action}>
                    <div
                        onClick={event => {
                            event.stopPropagation()
                            toggleStats()
                        }}
                    >
                        <IconPostStats />
                    </div>
                    <p>${amount}</p>
                </div>
            )}

{/*             <div className={styles.action}>
                <div
                    onClick={event => {
                        event.stopPropagation()
                        toggleLiked()
                    }}
                >
                    {liked ? (
                        <IconHeartFill />
                    ) : (
                        <IconHeartOutline
                            color={isEnabled ? '#fff' : '#afafaf'}
                        />
                    )}
                </div>
                {likeCount > 0 && (
                <p className='story_likecount'>{likeCount}</p>
                )}
            </div> */}

            {isEnabled && (
                <div
                    className={styles.action}
                    onClick={event => {
                        event.stopPropagation()

                        modal.addModal(
                            'Tip',
                            <TipModal
                                tipType="story"
                                modelData={{
                                    storyId: modelData?.storyId,
                                    modelId: modelData.modelId,
                                    avatarSrc: modelData.avatarSrc
                                }}
                            />
                        )
                    }}
                >
                    <IconLiveCircleTip color="#fff" />
                </div>
            )}
        </div>
    )
}
